// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-container {
  height: 100%;
  min-height: 300px;
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;
  overflow: hidden;
}
.map-container .map-frame {
  height: 100%;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}
.map-container .map-frame > div {
  height: 100% !important;
  width: 100% !important;
  max-width: 100% !important;
}

/* Ensure parent containers have height for MAP_VIEW_DETAIL */
eview-gmap {
  display: block;
  height: 100%;
  min-height: 300px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./libs/features/ui/map/map.componets.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AACF;AACE;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AACJ;AACI;EACE,uBAAA;EACA,sBAAA;EACA,0BAAA;AACN;;AAIA,6DAAA;AACA;EACE,cAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;AADF","sourcesContent":[".map-container {\n  height: 100%;\n  min-height: 300px;\n  width: 100%;\n  max-width: 100vw;\n  box-sizing: border-box;\n  overflow: hidden;\n  \n  .map-frame {\n    height: 100%;\n    width: 100%;\n    max-width: 100%;\n    box-sizing: border-box;\n    overflow: hidden;\n    \n    > div {\n      height: 100% !important;\n      width: 100% !important;\n      max-width: 100% !important;\n    }\n  }\n}\n\n/* Ensure parent containers have height for MAP_VIEW_DETAIL */\neview-gmap {\n  display: block;\n  height: 100%;\n  min-height: 300px;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
